// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1U2Gc","leftCol":"Header_leftCol__2sCSo","block":"Header_block__m6oSg","blockContent":"Header_blockContent__3iv6O","toBtn":"Header_toBtn__paah-"};